export default __webpack_public_path__ + "static/media/showcase-blue-icon.a1cdf0df.svg";